import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Toolbar, Button,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, MenuItem,
    Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import DeleteButton from '../components/DeleteButton';

function PaperComponent(props) {
    return (
        <Draggable handle="#notification-settings-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const NotificationSettings = ({ onClose }) => {

    const [subscriptions, setSubscriptions] = useState([]);
    const [usersSubscriptions, setUsersSubscriptions] = useState([]);
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [selectedSubscription, setSelectedSubscription] = useState('');

    useEffect(() => {
        loadAllSubscriptions();
        loadUsersSubscriptions();
    }, []);

    const loadAllSubscriptions = async () => {
        const response = await axios.get('/notification/subscription');
        setSubscriptions(response.data);
    };

    const loadUsersSubscriptions = async () => {
        const response = await axios.get('/notification/subscription/user');
        setUsersSubscriptions(response.data);
    };

    const onSave = async () => {
        await axios.post('/notification/subscription/user', usersSubscriptions);
        onClose();
    };

    const onDeleteClick = (index) => {
        const updatedSubscriptions = [...usersSubscriptions];
        updatedSubscriptions.splice(index, 1);
        setUsersSubscriptions(updatedSubscriptions);
    };

    const onAddSubscription = () => {
        if (selectedSubscription && !usersSubscriptions.includes(selectedSubscription)) {
            setUsersSubscriptions([...usersSubscriptions, selectedSubscription]);
        }
        setAddDialogOpen(false);
        setSelectedSubscription('');
    };

    return (
        <>
            <Dialog
                onClose={onClose}
                open={true}
                fullWidth
                PaperComponent={PaperComponent}
                BackdropProps={{
                    sx: {
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                    },
                }}
            >
                <Toolbar sx={{ m: 0, p: 0, display: 'flex' }}>
                    <DialogTitle id="notification-settings-dialog-title" sx={{ cursor: 'move' }}>
                        Notification Settings
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
                <DialogContent sx={{
                    m: 0,
                    p: 0,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    height: '400px',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Box>
                        <Button onClick={() => setAddDialogOpen(true)}>
                            Add Subscription
                        </Button>
                        <TableContainer sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {usersSubscriptions.map((subscription, index) => (
                                        <TableRow hover key={subscription}>
                                            <TableCell>{subscription}</TableCell>
                                            <TableCell>
                                                <DeleteButton confirmPopup onClick={() => onDeleteClick(index)} />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth onClick={onSave}>Save</Button>
                    <Button fullWidth onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} fullWidth>
                <DialogTitle>Add Subscription</DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="Select Subscription"
                        value={selectedSubscription}
                        onChange={(e) => setSelectedSubscription(e.target.value)}
                    >
                        {subscriptions.map((sub) => (
                            <MenuItem key={sub} value={sub}>
                                {sub}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onAddSubscription} disabled={!selectedSubscription}>Add</Button>
                    <Button onClick={() => setAddDialogOpen(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NotificationSettings;
